module.exports = __webpack_public_path__ + "img/logo-mini.827b811c.svg";